<template>
  <div
    class="expand-x"
    :style="{ width: width + 'px' }"
  >
    <div
      ref="content"
      class="content"
    >
      <slot />
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ExpandX',
  components: { /* Subcomponents */ },
  props: ['open'],
  data() {
    return {
      elem: null,
      content: {},
      width: 0,
      height: 0,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    open(newState, oldState) {
      if (newState) this.expand();
      if (!newState) this.collapse();
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.elem = this.$refs['content'];
    this.getDimensions();
    this.setHeight();
  },
  updated() {

  },
  methods: {
    getDimensions() {
      this.content = {
        width: this.elem.offsetWidth,
        height: this.elem.offsetHeight,
      };
    },
    setHeight() {
      this.height = this.content.height;
    },
    expand() {
      this.width = this.content.width;
    },
    collapse() {
      this.width = 0;
    },
  },
};
</script>


<style scoped>
  .expand-x {
    position: relative;
    overflow: hidden;
    transition: width 0.5s ease;
    height: 100%;
    /* border: 2px dashed black; */
  }
  .content {
    position: absolute;
    height: 100%;
  }
</style>
